<template>
  <div
    class="t-code-input"
    @paste.prevent="onPaste"
    @focusout="onFocusOut"
  >
    <div class="t-code-input__wrapper">
      <input
        v-for="(n, index) in length"
        :key="n"
        class="t-code-input__element"
        type="text"
        :placeholder="placeholder"
        maxlength="1"
        :autofocus="focused === index"
        v-bind="$attrs"
        :ref="`segment_${index}`"
        v-model="code[index]"
        @focus="focused = index"
        @input.stop="changeFocus"
      >
    </div>
  </div>
</template>

<script>
import ValidatableMixin from '../../mixins/ValidatableMixin';

export default {
  name: 't-code-input',

  mixins: [ValidatableMixin],

  props: {
    value: Array,
    placeholder: {
      type: String,
      default: '#',
    },
    length: {
      type: Number,
      default: 6,
    },
  },

  data() {
    return {
      focused: null,
      code: this.value || new Array(this.length),
    };
  },

  watch: {
    code(value) {
      const eventValue = this.uppercase ? value.map((segment) => segment.toUpperCase()) : value;

      this.$emit('input', eventValue);
      this.$emit('change', eventValue);
    },
  },

  methods: {
    onPaste(event) {
      let code = event.clipboardData.getData('text');
      code = code.replace(/[^A-Z0-9]/gi, '').substring(0, this.length);
      this.code = Array.from(code);
    },

    onFocusOut() {
      this.focused = null;
    },

    changeFocus(event) {
      if (event.inputType === 'deleteContentBackward') {
        if (this.focused === 0) return;
        this.$refs[`segment_${this.focused - 1}`][0].select();
      } else {
        if (this.focused === this.length - 1) return;
        this.$refs[`segment_${this.focused + 1}`][0].select();
      }
    },
  },
};
</script>
